import {Component, inject} from '@angular/core';
import {PrimeNgImportsModule} from '../../../../sdk/src/prime-ng-imports';
import {IBasePageComponent} from '../../../../sdk/src/components/ibase-page/ibase-page.component';
import {ProjectCRUDComponent} from '../../components/project-crud/project-crud.component';
import {ActivatedRoute} from '@angular/router';

/**
 * Enum representing available tabs in the projects page
 */
export enum EProjectsTab {
    PROJECTS = 'projects',
    GROUPS = 'groups'
}

@Component({
    selector: 'app-cp-instances-page',
    templateUrl: './cp-instances-page.component.html',
    imports: [PrimeNgImportsModule, ProjectCRUDComponent]
})
export class CPGInstancesPageComponent extends IBasePageComponent {
    protected readonly EProjectsTab = EProjectsTab;

    // ===============================================================
    // ===============================================================

    private readonly activatedRoute = inject(ActivatedRoute);

    // ===============================================================
    // ===============================================================

    /**
     * Gets the currently active tab from the URL query parameters.
     * Defaults to PROJECTS tab if no valid tab is specified in the URL.
     *
     * @returns The current active tab
     */
    protected get currentTab(): EProjectsTab {
        const tab = this.activatedRoute.snapshot.queryParams['tab'];
        return Object.values(EProjectsTab).includes(tab as EProjectsTab)
            ? (tab as EProjectsTab)
            : EProjectsTab.PROJECTS;
    }
    /**
     * Sets the active tab by updating the URL query parameters.
     * This maintains the tab state in the URL for bookmarking and navigation.
     *
     * @param value - The tab to activate
     */
    protected set currentTab(value: EProjectsTab) {
        this.globalsService.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: {tab: value},
            queryParamsHandling: 'merge'
        });
    }

    // ===============================================================
    // ===============================================================

    /**
     * On ready (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onReady(): Promise<void> {}
    /**
     * On destroy (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onDestroy(): Promise<void> {}
}
